import { IDeleteDiarioObraAtividadesUseCase } from "../../../presentation/useCases/delete/delete_diario_obras_atividades_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DeleteDiarioObraAtividadesUseCase

export class DeleteDiarioObraAtividadesUseCase implements IDeleteDiarioObraAtividadesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async deleteDiarioObraAtividades(IdDiarioObras: number, IdDiarioObrasAtividades: number): Promise<void> {
    await this.repository.deleteDiarioObraAtividades(IdDiarioObras, IdDiarioObrasAtividades);
  }
}
